// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qxnaxlobbexclduxxoxe.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF4bmF4bG9iYmV4Y2xkdXh4b3hlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDEzNTQ4MjMsImV4cCI6MjA1NjkzMDgyM30.VWKhBGPExAvH_RXTQj_RpczWDJ2aE6DEOAZ4v9XrHCE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);